<template>
    <content-loader
        :height="544"
        :width="1186"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
		<rect x="800" y="11" rx="4" ry="4" width="117" height="6.4" />
		<rect x="800" y="33.67" rx="3" ry="3" width="85" height="6.72" />
		<rect x="798.74" y="59.67" rx="0" ry="0" width="186.78" height="68" />
		<rect x="990.7" y="59.67" rx="0" ry="0" width="189.18" height="68" />
		<rect x="798.7" y="146.67" rx="0" ry="0" width="386" height="295" />
		<rect x="799.7" y="464.67" rx="0" ry="0" width="179" height="48" />
		<rect x="1007.7" y="465.67" rx="0" ry="0" width="180" height="49" />
		<rect x="0.7" y="440.67" rx="0" ry="0" width="779" height="104" />
    </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader"

export default {
    components: {
        ContentLoader
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/ContentLoaders/UsedDetailsHeader.vue